(function () {
  "use strict";

  var copyToClipBoard = {};

  let eventPage = $(".qld__event");

  copyToClipBoard.init = function (text, $el) {
    if (navigator.clipboard) {
      // All popular browsers
      navigator.clipboard.writeText(text).then(
        function () {
          if ($el) {
            $el
              .find(".qld__copied-to-clipboard")
              .toggleClass("active")
              .text("Copied")
              .fadeOut(1400, function () {
                $(this).empty().show().toggleClass("active");
              });
          } else {
            $(".qld__copied-to-clipboard")
              .toggleClass("active")
              .text("Copied")
              .fadeOut(1400, function () {
                $(this).empty().show().toggleClass("active");
              });
          }
        },
        function (err) {
          console.log(
            "Clipboad API not available, please upgrade your browser.",
          );
        },
      );
    } else if (window.clipboardData) {
      // IE11
      window.clipboardData.setData("Text", text);
    }
  };

  QLD.copyToClipBoard = copyToClipBoard;

  $(function () {
    if (eventPage.length > 0) {
      console.log("init");

      $(".qld__event-article__copy-link").on("click", function () {
        console.log("click");
        QLD.copyToClipBoard.init($(this).find("span").text(), $(this));
      });

      $('.qld__event-article__copy-link span[tabindex="0"]').keypress(
        function (e) {
          var keycode = e.keyCode ? e.keyCode : e.which;
          console.log("click");
          if (keycode == "32" || keycode == "13") {
            e.preventDefault();
            QLD.copyToClipBoard.init($(this).find("span").text());
          }
        },
      );
    }
  });
})();
